/**
 * @generated SignedSource<<42bdc5594154081441f6afe33c3db8af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PaymentMethodEligibilityType = "ACH" | "APPLE_PAY" | "CHECK" | "CREDIT_CARD" | "KLARNA" | "ON_PLATFORM_WIRE_TRANSFER" | "PAYPAL_ACCOUNT" | "WIRE_TRANSFER" | "card" | "customer_balance" | "us_bank_account" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutPaymentStepSubmit_transaction$data = {
  readonly eligibleStripeACH: ReadonlyArray<PaymentMethodEligibilityType | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountsSubmitStripe_transaction" | "CheckoutBankAccountsSubmit_transaction">;
  readonly " $fragmentType": "CheckoutPaymentStepSubmit_transaction";
};
export type CheckoutPaymentStepSubmit_transaction$key = {
  readonly " $data"?: CheckoutPaymentStepSubmit_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPaymentStepSubmit_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPaymentStepSubmit_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmit_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountsSubmitStripe_transaction"
    },
    {
      "alias": "eligibleStripeACH",
      "args": [
        {
          "kind": "Literal",
          "name": "paymentMethods",
          "value": [
            "ACH"
          ]
        },
        {
          "kind": "Literal",
          "name": "paymentProcessor",
          "value": "STRIPE"
        }
      ],
      "kind": "ScalarField",
      "name": "eligiblePaymentMethods",
      "storageKey": "eligiblePaymentMethods(paymentMethods:[\"ACH\"],paymentProcessor:\"STRIPE\")"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "a413350214be9d32929e9a851e938476";

export default node;
